<div class="card-grid">
    @for (preconf of preconfigurations | async; track preconf) {
        <div class="card-grid-item">
            <app-preconfig-card [data]="preconf" [longestName]="longestName | async" [activeCode]="activeCode"
                                [showLogo]="showLogo" (click)="selectConfiguration(preconf.code, preconf.price)"/>
        </div>
    }
</div>
